// test2372
(2372 && 0);
